import React, { useState } from "react";

// Hand-rolled, React-state-driven accordion (no Bootstrap JS/data-bs-toggle,
// consistent with this codebase's boolean-state-controlled modal pattern).
const Accordion = ({ children, className = "" }) => (
  <div className={`app-accordion ${className}`}>{children}</div>
);

const AccordionItem = ({ title, icon, meta, defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`app-accordion-item ${open ? "open" : ""}`}>
      <button
        type="button"
        className="app-accordion-header"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        {icon && <i className={`fas ${icon} app-accordion-icon`}></i>}
        <span className="app-accordion-title">{title}</span>
        {meta}
        <i className="fas fa-chevron-down app-accordion-chevron"></i>
      </button>
      {open && <div className="app-accordion-body">{children}</div>}
    </div>
  );
};

Accordion.Item = AccordionItem;

export default Accordion;
